import styled from "styled-components";
import {
  COLORS,
  TYPOGRAPHY,
  BREAKPOINTS
} from "containers/impact-report/constants";

export const FaqSection = styled.section`
  width: 100%;
  background-color: ${COLORS.WHITE};
  padding: 60px 24px 80px 24px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    padding: 100px 40px 130px 40px;
  }
`;

export const ContentWrapper = styled.div`
  @media (min-width: ${BREAKPOINTS.MD}) {
    max-width: 1030px;
    margin: 0 auto;
  }
`;

export const SectionTitle = styled.h2`
  ${TYPOGRAPHY.H2_MOBILE}
  color: ${COLORS.NEUTRAL_500};
  margin: 0 0 24px 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.H2_DESKTOP}
    margin: 0 0 40px 0;
  }
`;

export const FaqItem = styled.div`
  border-bottom: 1px solid ${COLORS.BORDER_COLOR};

  &:last-child {
    border-bottom: none;
  }
`;

export const QuestionButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  gap: 16px;

  &:focus {
    outline: 2px solid ${COLORS.LINK_BLUE};
    outline-offset: 2px;
  }
`;

export const QuestionText = styled.span`
  ${TYPOGRAPHY.P_BOLD_MOBILE}
  color: ${COLORS.NEUTRAL_500};
  flex: 1;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.P_BOLD_DESKTOP}
  }
`;

export const AnswerWrapper = styled.div`
  max-height: ${props => (props.isOpen ? "2000px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease;
`;

export const AnswerText = styled.p`
  ${TYPOGRAPHY.BODY_LARGE_LIGHT}
  color: ${COLORS.NEUTRAL_500};
  margin: 0 0 16px 0;
  padding-bottom: ${props => (props.isLast ? "24px" : "0")};

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 24px;
  }

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.P_DESKTOP}
  }
`;

export const AnswerList = styled.ul`
  ${TYPOGRAPHY.BODY_LARGE_LIGHT}
  color: ${COLORS.NEUTRAL_500};
  margin: 0 0 16px 0;
  padding-left: 24px;

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 24px;
  }

  li {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.P_DESKTOP}
  }
`;

export const AnswerLink = styled.a`
  color: ${COLORS.LINK_BLUE};
  text-decoration: underline;
  cursor: pointer;

  &:focus {
    outline: 2px solid ${COLORS.LINK_BLUE};
    outline-offset: 2px;
  }
`;

export const FooterLink = styled.a`
  ${TYPOGRAPHY.BODY_LARGE_MEDIUM}
  color: ${COLORS.PRIMARY_600};
  text-decoration: underline;
  display: inline-block;
  margin-top: 30px;
  cursor: pointer;

  &:focus {
    outline: 2px solid ${COLORS.PRIMARY_600};
    outline-offset: 2px;
  }

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.P_BOLD_DESKTOP}
  }
`;
